
import { computed, defineComponent, inject } from "vue";
import { StoreKey } from "@/symbols";

import SubtitleElement from "./SubtitleElement.vue";

export default defineComponent({
  name: "SubtitleTracklistViewer",

  components: {
    SubtitleElement
  },

  setup() {
    const store = inject(StoreKey);
    if (!store) {
      throw new Error(`Could not resolve ${StoreKey.description}`);
    }

    const cues = computed(() => store.state.cues);
    return {
      cues
    };
  }
});
